import React from 'react'

/**
 * TODO: Dialog form members removal confirmation.
 */
class MemberRemovalDialog extends React.Component {
  
  render() {
    return null
  }

}

export default MemberRemovalDialog


// WEBPACK FOOTER //
// ./src/team/MemberRemovalDialog.js